import React from 'react';
import {
  Box,
  Flex,
  PopoverContent,
  PopoverArrow,
  Popover,
  PopoverHeader,
  PopoverTrigger,
  PopoverBody,
} from '@chakra-ui/react';
import {
  BusinessAudience,
  PrimaryBusinessCategory,
  SecondaryBusinessCategory,
} from '../../shared/account';
import {
  PrimaryCategoriesRenderer,
  AudienceRenderer,
} from './AccountGrid.components';
import {CategoriesSection} from './AccountGrid.details';

const _CategoriesAndAudienceRenderer = ({
  audiences,
  primaryCategories,
  secondaryCategories,
}: {
  audiences: BusinessAudience[];
  primaryCategories: PrimaryBusinessCategory[];
  secondaryCategories: SecondaryBusinessCategory[];
}) => {
  return (
    <Popover isLazy={true} placement="end" trigger="hover">
      <PopoverTrigger>
        <Box>
          <Flex alignItems="baseline" wrap="wrap" gap={2}>
            <PrimaryCategoriesRenderer categories={primaryCategories} />
            <AudienceRenderer audiences={audiences} />
            {secondaryCategories.length > 0 ? (
              <Box color="kgray.300" fontSize="xs" px="2">
                +{secondaryCategories.length} more
              </Box>
            ) : (
              <></>
            )}
          </Flex>
        </Box>
      </PopoverTrigger>
      <PopoverContent p={2}>
        <PopoverArrow />
        <PopoverHeader border={0} fontWeight={500}>
          Categories
        </PopoverHeader>
        <PopoverBody>
          <CategoriesSection
            audiences={audiences}
            primaryCategories={primaryCategories}
            secondaryCategories={secondaryCategories}
          />
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export const CategoriesAndAudienceRenderer = React.memo(
  _CategoriesAndAudienceRenderer
);
